import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ArchivoCrm } from '../models/archivocrm.model';
@Injectable({
  providedIn: 'root'
})
export class AdjuntoService {
  urls = GlobalVariable.API_Admision;
  APi = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });
  constructor(private http: HttpClient) { }

  public GetRequeridos(codigoinstitucion: string, anhoacademico: any, tipoingreso: any) {
    return this.http.post(`${this.urls}doc/requeridos?codigoinstitucion=${codigoinstitucion}&anhoacademico=${anhoacademico}&tipoingreso=${tipoingreso}`, null, { headers: this.headersc });
  }

  public AdjuntarNota(idProceso: string, file: File,name:string) {
    const formData = new FormData();
    formData.append('IdReference', idProceso);
    formData.append('file', file, name +'.'+file.name.split('.').pop());
    const headersc = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', this.token);

    const uploadReq = new HttpRequest('POST', `${this.APi}Documentos/AttachDocument`, formData, {
      headers: headersc,
      reportProgress: true,
      withCredentials: false
    });
    // Set Header
    uploadReq.headers
      .set('Authorization', this.token);

    return this.http.request(uploadReq);
  }
  public UpdateNota(idProceso: string, file: File,name:string,idNota:string) {
    const formData = new FormData();
    formData.append('IdReference', idProceso);
    formData.append('file', file, name +'.'+file.name.split('.').pop());
    formData.append('IdAdjunto', idNota);
    const headersc = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', this.token);

    const uploadReq = new HttpRequest('POST', `${this.APi}Documentos/AttachDocument`, formData, {
      headers: headersc,
      reportProgress: true,
      withCredentials: false
    });
    // Set Header
    uploadReq.headers
      .set('Authorization', this.token);

    return this.http.request(uploadReq);
  }
  public GetEstadoDocumentos(idProceso: string) {
    return this.http.post(`${this.APi}Documentos/GetEstadoDocumentos?IdProceso=${idProceso}`, null, { headers: this.headers });
  }
  public SetDocumentosRequeridos(model:ArchivoCrm) {
    return this.http.post(`${this.APi}Documentos/SetDocumentosRequeridos`, JSON.stringify(model), { headers: this.headers });
  }

  public DescargarNotaCRM(idFile:string){
    return this.http.post(`${this.APi}Generales/GetAdjunto/?idAdjunto=${idFile}`, null, {  'responseType'  : 'arraybuffer' as 'json',headers: this.headersc });
  }
}
